import React from 'react';
import { Button, Intent, Tag } from '@blueprintjs/core';
import { Tooltip2 } from '@blueprintjs/popover2';
import { IconNames } from '@blueprintjs/icons';
import { gql } from '@apollo/client';
import PersonIconList from '../../../components/PersonIconList';
import TableCell from '../../../components/TableCell';
import Text from '../../../components/Text';
import { CompanionMatchListItemFragment } from '../../../generated/graphql';
import { getAgeInYears } from '../../../helpers/dateTimeUtils';

export type CompanionMatchListItemProps = {
  soulSignupId: string;
  soulBuysTicket: boolean;
  companionSignup: CompanionMatchListItemFragment;
  isActive: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  addTeam: (companionSignupId: string, soulSignupId: string, soulBuysTicket: boolean) => void;
};

const CompanionMatchListItem = ({
  soulSignupId,
  soulBuysTicket,
  companionSignup,
  isActive,
  onMouseLeave,
  onMouseEnter,
  addTeam,
}: CompanionMatchListItemProps) => {
  const prospect = companionSignup.companion!;
  const { organisation } = prospect;

  return (
    <tr onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className={isActive ? 'active' : ''}>
      <TableCell>
        {prospect!.display_name}
        {!!prospect.birthdate && <Text muted> ({getAgeInYears(prospect.birthdate).toString()})</Text>}
        <br />
        {!!organisation && (
          <Text small muted>
            {organisation.name}
          </Text>
        )}
      </TableCell>
      <TableCell>
        {!prospect.lat && (
          <Tag intent={Intent.WARNING} minimal className="ml-1">
            Adresse Fehlt
          </Tag>
        )}
        <PersonIconList person={prospect} />
        <br />
        <Text small muted>
          {companionSignup.notes}
        </Text>
      </TableCell>
      <TableCell>{companionSignup.priority}</TableCell>
      <TableCell>
        <Tooltip2 content={`Mit ${prospect.display_name} als Begleitung auf die Teilnehmerliste`}>
          <Button
            small
            icon={IconNames.SMALL_TICK}
            intent={Intent.SUCCESS}
            onClick={() => addTeam(companionSignup.id, soulSignupId, soulBuysTicket)}
          />
        </Tooltip2>
      </TableCell>
    </tr>
  );
};

CompanionMatchListItem.fragments = {
  companion: gql`
    fragment CompanionMatchListItem on Signup {
      id
      event_id
      token
      is_candidate
      is_invited
      has_accepted
      has_rejected
      notes
      priority
      companion {
        id
        display_name
        birthdate
        email
        phone
        mobile
        lat
        lng
        notes
        meta {
          can_blind
          can_wheelchair
          can_wheeled_walker
          can_drive
        }
        tags {
          id
          name
          icon
          intent
        }
        organisation {
          id
          name
        }
      }
    }
  `,
};

export default CompanionMatchListItem;
